import {createStore} from "vuex";
import ModelStore from "@km/store/modelStore";
import EntwurfStore from "@km/store/EntwurfStore";
import UserStore from "@km/store/UserStore";
import LogoPoolStore from "@km/store/LogoPoolStore";
import EntwurfListeStore from "@km/store/EntwurfListeStore";
import InfoFromGetParametersStore from "@km/store/InfoFromGetParametersStore";
import resourceManagerStore from "@km/store/resourceManagerStore";
import taskrunnerStore from "@km/store/taskrunnerStore";
import OrderStore from "@km/store/OrderStore";
import WarenkorbZusammenfassung from "@km/store/WarenkorbZusammenfassung";
import StockLogoStore from "@km/store/StockLogoStore";
import ProduktAuswahlStore from "./store/ProduktAuswahlStore"
import FontStore from "@km/store/FontStore";
import TabOpenStatusStore from "@km/store/frontendstate/TabOpenStatusStore";


import debugStore from "@km/store/debugStore";
import laenderlistenStore from "@km/store/laenderlistenStore";
import kilogodatenstore from "@km/store/kilogodatenstore";
import readyDesignsStore from "@km/store/readyDesignsStore";
const store = createStore({
    modules: {
        EntwurfStore,
        UserStore,
        LogoPoolStore,
        EntwurfListeStore,
        InfoFromGetParametersStore,
        resourceManagerStore,
        taskrunnerStore,
        OrderStore,
        WarenkorbZusammenfassung,
        StockLogoStore,
        ProduktAuswahlStore,
        TabOpenStatusStore,
        FontStore,
        ModelStore,
        debugStore,
        laenderlistenStore,
        kilogodatenstore,
        readyDesignsStore
    }
})

export default store;









